<template>
  <div class="top-bar" :class="{ 'scrolled': isScrolled }">
    <div class="top-bar-left">
      <button class="sidebar-toggle-btn" @click="toggleSidebar">
        <i class="material-icons">menu</i>
      </button>
      <h1 class="heading1">IT PORTAL</h1>
    </div>
    <div id="searchfield">
      <form action="/dashboard" method="POST" id="formName">
        <autocomplete
          :source="source"
          results-value="link"
          :results-display="formattedDisplay"
          @selected="getSelected"
        >
        </autocomplete>
      </form>
    </div>
  </div>
</template>

<script>
import Autocomplete from 'vuejs-auto-complete';

export default {
  name: 'TopBar',
  components: {
    autocomplete: Autocomplete
  },
  props: {
    source: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isScrolled: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    toggleSidebar() {
      this.$emit('toggle-sidebar');
    },
    getSelected(result) {
      window.open(result.value, "_blank");
      this.$emit('selected', result);
    },
    formattedDisplay(result) {
      return result.text;
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 10;
    }
  }
};
</script>

<style scoped>
.top-bar {
  background: #fff;
  padding: 15px 30px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10;
  position: sticky;
  top: 0;
  transition: box-shadow 0.3s ease, padding 0.3s ease;
}

.top-bar.scrolled {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  padding: 10px 30px;
}

.top-bar-left {
  display: flex;
  align-items: center;
}

.sidebar-toggle-btn {
  display: none;
  background: none;
  border: none;
  color: #00205b;
  cursor: pointer;
  margin-right: 15px;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.sidebar-toggle-btn:hover {
  background-color: rgba(0, 32, 91, 0.05);
}

.sidebar-toggle-btn i {
  font-size: 24px;
}

.top-bar .heading1 {
  margin: 0;
  font-size: 1.8rem;
  color: #00205b;
  font-family: 'Zen Kaku Gothic New', sans-serif;
  font-weight: 700;
}

#searchfield {
  width: 400px;
}

#searchfield form {
  margin: 0;
}

@media (max-width: 992px) {
  .top-bar {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px 20px;
  }

  .top-bar .heading1 {
    margin-bottom: 3px;
  }

  #searchfield {
    width: 100%;
  }

  .sidebar-toggle-btn {
    display: block;
  }
}

@media (max-width: 768px) {
  .top-bar-left {
    width: 100%;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue